module.exports = __webpack_public_path__ + "static/media/f2.a6276fa4.png";